import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFilter, faPlus, faTrashAlt, faClipboardList, faPrint } from '@fortawesome/free-solid-svg-icons';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        certificados_generados: []
    }

    ListarCertificados(page) {
        Swal.showLoading();
        let btype = document.getElementById('btype').value;
        let bname = document.getElementById('bnombre').value;
        if (btype == '') {
            btype = 0;
        }
        if (bname == '') {
            bname = 0;
        }
        authAxios.get("formulario/certificados_generados/" + btype + "/" + bname + "?page=" + page)
            .then((datosRespuesta) => {
                Swal.close();
                console.log(datosRespuesta);
                var status = datosRespuesta.status;
                if (!status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a iniciar session', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({
                    datosCargados: true,
                    load: '',
                    certificados_generados: datosRespuesta.data.certificados_generados.data,
                    pagina: datosRespuesta.data.certificados_generados.total,
                    ultimo: datosRespuesta.data.certificados_generados.last_page,
                    actual: datosRespuesta.data.certificados_generados.current_page
                });
            })
            .catch(console.log);
    }

    componentDidMount() {
        this.ListarCertificados(1);
    }
    render() {
        const { load, certificados_generados, pagina, ultimo, actual } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-success btn-sm" to={"/AddCertificados"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Generar Nuevo Certificado</Link>
                        </div>
                        <div className="card-body">
                            <h4>Lista Certificados Generados</h4>
                            <hr />
                            <div className="row">
                                <div className="col-xl-2">
                                    <select name="btype" id="btype"
                                        className={"form-select form-select-sm"}>
                                        <option value="">-</option>
                                        <option value="1">NIT</option>
                                    </select>
                                </div>
                                <div className="col-xl-3">
                                    <input style={{ textTransform: 'uppercase' }} type="text" id="bnombre" name="bnombre" placeholder="BUSCAR CERTIFICADO" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-3">
                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarCertificados(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <table className="table table-hover table-condensed table-sm">
                                    <thead className="thead-inverse">
                                        <tr>
                                            <th className="align-middle">NIT TERCERO</th>
                                            <th className="align-middle">EMPRESA GRUPO</th>
                                            <th className="align-middle">AÑO CERTIFICADO</th>
                                            <th className="align-middle">TIPO CERTIFICADO</th>
                                            <th className="align-middle">FECHA GENERACIÓN</th>
                                            {/* <th className="align-middle">OPCIONES</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {load}
                                        {
                                            certificados_generados.map((itemCertificados) => (
                                                <tr key={itemCertificados.id}>
                                                    <td>{itemCertificados.nit_tercero}</td>
                                                    <td>{itemCertificados.nombre}</td>
                                                    <td>{itemCertificados.ano_certificado}</td>
                                                    <td>{itemCertificados.tipo_certificado}</td>
                                                    <td>{itemCertificados.created_at}</td>
                                                    {/* <td>
                                                        <div className="btn-group" role="group" aria-label="">
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary btn-sm"
                                                                data-bs-toggle='modal'
                                                                data-bs-target="#PDFCertificadoModal"
                                                                slot='end'
                                                                onClick={() => {
                                                                    this.previewPDFCertificado(itemCertificados.id)
                                                                }}
                                                            >
                                                                <FontAwesomeIcon icon={faPrint} />
                                                            </button>
                                                        </div>
                                                    </td> */}
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarCertificados(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarCertificados(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarRol(actual)}>{actual}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarCertificados(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarCertificados(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                        </div>
                    </div>
                </div>
                {/* Modals */}
                {/* <div className="modal fade" id="PDFCertificadoModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="PDFCertificadoModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className='col-9'>
                                    <h4 className="modal-title w-100 text-center" id="">Certificado</h4>
                                </div>
                                <div className='col-2'>
                                    <PDFDownloadLink
                                        document={<PDFQuotations data={quotationData} />}
                                        fileName={filename}
                                    >
                                        {({ loading }) =>
                                            loading ? "Loading..." : <button className="btn btn-success"> Descargar PDF <FontAwesomeIcon icon={faPrint} /></button>
                                        }
                                    </PDFDownloadLink>
                                </div>
                                <div className='col-1'>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <PDFViewer style={{ width: "100%", height: "90vh" }}>
                                            <PDFQuotations data={quotationData} />
                                        </PDFViewer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        );
    }
}

export default Listar;